<template>
  <div class="view categories">
    <h1 v-if="type === 'activity'">{{ $t('home.tabs.activity') }}</h1>
    <h1 v-if="type === 'package'">{{ $t('home.tabs.package') }}</h1>
    <h1 v-if="type === 'product'">{{ $t('home.tabs.product') }}</h1>
    <category-list :type="type" />
  </div>
</template>

<script>
// @ is an alias to /src
import CategoryList from '@/components/CategoryList.vue'

export default {
  props: ['type'],

  components: {
    CategoryList
  },

  created() {
  },

  data() {
    return {
    }
  },

  // watch: {
  //   '$route': 'routeChanged'
  // },

  // methods: {
  //   routeChanged() {
  //     console.log(`category route changed ${this.type}`);
  //   }
  // }
}
</script>
